export const beachCategoriesOptions = [
    { label: "Fitness", value: "fitness" },
    { label: "Divertimento", value: "fun" },
    { label: "Relax", value: "relax" },
    { label: "Bambini", value: "baby" },
    { label: "Famiglie", value: "family" },
    { label: "Dog-friendly", value: "dog" },
    { label: "Coppie", value: "love" },
]
